/**
 * props: {
 *     showActionItemFlag: 是否显示操作里后台返回的操作项，用于外部扩展自己的操作项，默认显示
 *     hideLineActions：是否隐藏列表的操作栏，用于外部控制，默认显示false
 *     needSelectAction: 点击一行时是否需要请求操作接口，默认为true请求
 *     tableSortable: 列表是否支持拖拽排序
 * }
 */
import { createAPI } from '@common'

export default {
  props: {
    e5namespace: {
      type: String,
      required: true
    },
    highlightCurrentRow: { // 点击当前行是否高亮, 注意:checkbox选中也会有高亮, 他们是两个不同的高亮状态, 有checkbox时可以把此属性设置为false
      type: Boolean,
      default: false
    },
    propsGetOpenUrl: {
      type: Function,
      default () {
        return '#'
      }
    },
    showActionItemFlag: {
      type: Boolean,
      default: true
    },
    hideLineActions: {
      type: Boolean,
      default: false
    },
    tableMaxHeight: {
      type: [String, Number],
      default: 'none'
    },
    actionWidth: {
      type: String,
      default: '100'
    },
    actionFixedWidth: {
      type: String,
      default: 'auto'
    },
    /**
     * 20200414
     * 不需要了，目前修改为显示右键菜单，这个控制没用了
     */
    contextMenuFlag: {
      type: Boolean,
      default: true
    },
    propDialogComponent: {
      type: Object,
      default () {
        return {}
      }
    },
    autoLoadData: { // 自动加载数据
      type: Boolean,
      default: false
    },
    needRadio: { // 需要单选
      type: Boolean,
      default: false
    },
    needSelectAction: {
      type: Boolean,
      default: true
    },
    tableSortable: {
      type: Boolean,
      default: false
    },
    subComConfig: {
      type: Object,
      default () {
        return {
          e5namespace: this.e5namespace
        }
      }
    },
    updateOrderApi: {
      type: String,
      default: '/v1/articles/sorting' // 默认调用app发布库的更新排序接口
    },
    updateOrderColumn: {
      type: [String, Number],
      default: undefined
    },
    fromArticleAddLive: {
      type: Boolean,
      default: false
    },
    isShowCheckbox: { // 后台返回不需要checkbox时，前端决定是否需要checkbox，默认不需要
      type: Boolean,
      default: false
    },
    // 是否需要刷新列表数据时默认选中列表数据，默认需要【参考：目前在推荐管理-新建-选稿中设置为false】
    isNeedRefreshDefaultChecked: {
      type: Boolean,
      default: true
    },
    /**
     * 用来设置列表中点击某一项打开的dialog的一些属性，目前只支持设置dialog的宽高
     * 数据结构：
     * [{
     *     modDetail: '', // 打开模块名，要和后台配置返回的保持一致
     *     width: '1000px',
     *     height: '500px'
     * }]
     */
    detailDialogConfigs: {
      type: Array,
      default: () => { return [] }
    },
    isNeedHub: {
      type: Boolean,
      default: false
    },
    isRowSelect: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      actionRequestTimer: null,
      isCtrldown: false, // 是否按下ctrl键
      isShiftdown: false, // 是否按下shift键
      tableRequestTimer: null,
      updateOrderDialogVisible: false // 更新排序成功的dialog
    }
  },
 computed: {
   ids: function () {
     return this.$store.state[this.e5namespace].ids
   },
   tableData: function () {
     return this.$store.state[this.e5namespace].tableFormat
   },
   tableSelectedRows () {
     return this.$store.state[this.e5namespace].tableSelectedRows // checkbox选中行
   },
   paginationData: function () {
     return this.$store.state[this.e5namespace].paginationData
   },
   formData: function () {
     return this.$store.state[this.e5namespace].formData
   },
   tableSortColumn: function () {
     return this.$store.state[this.e5namespace].tableSortColumn
   },
   tableType: function () {
     return this.$store.state[this.e5namespace].tableType
   },
   metadata: function () {
     return this.$store.state[this.e5namespace].metadata
   },
   tableFormat () {
     return this.$store.state[this.e5namespace].tableFormat
   },
   currentPreaction () {
     return this.$store.state[this.e5namespace].currentPreaction
   },
   tableSortData: function () {
     return this.$store.state[this.e5namespace].tableSortData
   }
 },
  created () {
    if (this.autoLoadData) {
      this.refreshTable()
    }
  },
 methods: {
   refreshTable () {
     let _this = this
     if (_this.tableRequestTimer === null) {
       // 防止多次触发选择事件导致多次请求
       _this.tableRequestTimer = setTimeout(function () {
         _this.FETCH_GET_E5_CONDITIONS().then(() => {
           _this.FETCH_GET_E5_LISTS().then(() => {
             _this.FETCH_POST_E5_LIST_DATA()
           })
         })
         _this.FETCH_GET_E5_ACTIONS({
           config: {
             hubConfig: _this.isNeedHub
           },
           vconfig: {
             e5namespace: _this.e5namespace}})
         clearTimeout(_this.tableRequestTimer)
         _this.tableRequestTimer = null
       }, 500)
     }
   },
   FETCH_GET_E5_CONDITIONS: function () {
     return this.$store.dispatch(this.e5namespace + '/FETCH_GET_E5_CONDITIONS', {
       config: {
         hubConfig: this.isNeedHub
       },
       vconfig: {
         e5namespace: this.e5namespace
       }
     })
   },
   // 更新table的header
   FETCH_GET_E5_LISTS: function () {
     return this.$store.dispatch(this.e5namespace + '/FETCH_GET_E5_LISTS', {
       config: {
         hubConfig: this.isNeedHub
       },
       vconfig: {
         e5namespace: this.e5namespace
       }
     })
   },
   updateOriginalData () {
     return this.$store.dispatch(this.e5namespace + '/updateOriginalData', ...arguments)
   },
   // 更新列表操作按钮
   FETCH_GET_E5_ACTIONS () {
     return this.$store.dispatch(this.e5namespace + '/FETCH_GET_E5_ACTIONS', ...arguments)
   },
   FETCH_TABLE_SELECTED_ROWS (val) {
     return this.$store.dispatch(this.e5namespace + '/FETCH_TABLE_SELECTED_ROWS', val)
   },
   FETCH_TABLE_SORT_COLUMN () {
     return this.$store.dispatch(this.e5namespace + '/FETCH_TABLE_SORT_COLUMN', ...arguments)
   },
   /**
    * 当鼠标点击某一行的时候，
    *  1. 判断显示按钮
    *  2. 判断显示鼠标右键
    */
   handleRowContextMenu (row, event, column) {
     if (this.isRowSelect) {
       // if (this.contextMenuFlag) {
       // 右键菜单打开:  当只有一行选中为单选切换
       if (this.tableSelectedRows.length && this.tableSelectedRows.length < 2) {
         this.$refs.table.clearSelection()
       }
       this.$store.state[this.e5namespace].actions = []
       this.limitGetActions(500)
       this.$refs.table.toggleRowSelection(row, true)
       this.$refs.tableMenu.open(event)
       // }
     }
   },
   // table的选择项发生改变，val为所有选择项的list
   handleSelectionChange (val) {
    if (this.fromArticleAddLive) {
      if (val.length > 1) {
        this.$refs.table.clearSelection()
        this.$refs.table.toggleRowSelection(val.shift())
      }
      this.selectedRow = val
    } else {
      this.FETCH_TABLE_SELECTED_ROWS(val)
      this.limitGetActions(500)
    }
    this.$emit('handleSelectionChange', val)
   },
    setCurrent (row) {
      if (this.fromArticleAddLive) {
        this.$refs.table.setCurrentRow(row)
      }
    },
    handleCurrentChange (val) {
      if (this.fromArticleAddLive) {
        this.currentRow = val
      }
    },
   /**
    * 控制多次请求actions
    * @param delay 请求间隔时间
    */
   limitGetActions (delay) {
     let _this = this
     if (_this.actionRequestTimer === null && this.needSelectAction) {
       // 防止多次触发选择事件导致多次请求
       _this.actionRequestTimer = setTimeout(function () {
         _this.FETCH_GET_E5_ACTIONS({
           config: {
             params: {
               params: {
                 ids: _this.ids
               }
             },
             hubConfig: _this.isNeedHub
           },
           vconfig: {
             e5namespace: _this.e5namespace}
         })
         clearTimeout(_this.actionRequestTimer)
         _this.actionRequestTimer = null
       }, delay)
     }
   },
   handleSortChange (val) {
     if (val && val.column === null) {
       // 没有排序数据 则取默认排序
       val.prop = this.tableType.sortby
       val.order = this.tableType.sorttype
     }
     this.FETCH_TABLE_SORT_COLUMN(val).then(() => {
       this.FETCH_POST_E5_LIST_DATA()
     })
     this.$emit('handleSortChange')
   },
   handleRowClick (row, event, column) {
     if (this.isRowSelect) {
       let val = {row, event, column}
       if (!this.isCtrldown && !this.isShiftdown) { // 不按住ctrl或shift是单选
         this.$refs.table.clearSelection() // 点击当前行需要单选
       }
       if (this.isShiftdown) {
         // shift 多选功能
         if (this.tableSelectedRows.length && this.tableSelectedRows.length > 0) {
           let preRow = this.tableSelectedRows[0] // 获取起始cell
           let begin = null // 起始cell在tableData 中的位置
           let end = null
           for (let i = 0, arr = this.tableData, len = arr.length; i < len; i++) {
             if (begin === null && (preRow.id === arr[i].id || val.row.id === arr[i].id)) {
               begin = i
             } else if (end === null && (preRow.id === arr[i].id || val.row.id === arr[i].id)) {
               end = i
             }
             if (begin !== null && (end === null || i <= end)) {
               this.$refs.table.toggleRowSelection(arr[i], true)
             }
           }
           return
         }
       }
       // 多选-取消选中功能
       if (this.tableSelectedRows.length && this.tableSelectedRows.length > 0) {
         for (let i = 0, arr = this.tableSelectedRows, len = arr.length; i < len; i++) {
           if (val.row.id === arr[i].id) {
             this.$refs.table.toggleRowSelection(val.row, false) // 多选时判断再次点击取消选中
             return
           }
         }
       }
       // 单选功能
       this.$refs.table.toggleRowSelection(val.row)
     }
   },
   openDialog (action) {
     this.$emit('openDialog', action)
   },
   openDetailDialog (data) {
     for (let i in this.detailDialogConfigs) {
       if (data.modDetail === this.detailDialogConfigs[i].modDetail) {
         data.width = this.detailDialogConfigs[i].width || '800px'
         break
       }
     }
     this.$refs.detailDialog.openDetailDialog(data)
   },
   openWindow (action) {
     this.$emit('openWindow', action)
   },
   openNoneAction (action) {
     this.$emit('openNone', action)
   },
   addCb (e) {
     e.preventDefault()
     window.actionSuccessCb = this.FETCH_POST_E5_LIST_DATA
     window.open(e.target.href)
   },
   detailAction (item, rowOriginal) {
     window.actionSuccessCb = this.FETCH_POST_E5_LIST_DATA

     this.updateOriginalData(rowOriginal)
     if (item.modeDetail && item.modeDetail === 'DIALOG') {
       this.$emit('openDetailDialog', item)
     }
   },
   // 更新table的data
   FETCH_POST_E5_LIST_DATA: function (isHideLoading) {
     return this.$store.dispatch(this.e5namespace + '/FETCH_POST_E5_LIST_DATA', {
       vconfig: {
         e5namespace: this.e5namespace,
         neverLoading: isHideLoading
       },
       config: {
         hubConfig: this.isNeedHub,
         data: {
           list: this.tableType.id,
           page: this.paginationData.currentPage,
           count: this.paginationData.pageSize,
           sortby: this.tableSortColumn.prop,
           sortType: this.tableSortColumn.order,
           conditions: this.formData,
           ...this.metadata
         }
       }
     })
   },

   handleSelect (selection, row) {
     if (this.fromArticleAddLive) {
        if (selection.length > 1) {
          this.$refs.table.clearSelection()
          this.$refs.table.toggleRowSelection(selection.pop())
        }
     } else {
        if (this.needRadio) {
         this.handleRowClick(row)
        }
         this.$emit('handleSelect', {selection, row})
        }
   },
   /* HandleTableItemEdit (item) {
     this.$emit('HandleTableItemEdit', item)
   }, */
    getOpenUrl (data, rowOriginal) {
       if (data) {
         return this.propsGetOpenUrl({item: data, id: rowOriginal.id, rowOriginal: rowOriginal})
       } else {
         return '#'
       }
    },
   /**
    * table 行className回调
    * @param row 每行数据
    * @returns {string} 样式名
    */
   rowClassName (row) {
     // 多选高亮
     if (this.tableSelectedRows.length && this.tableSelectedRows.length > 0) {
       for (let i = 0, arr = this.tableSelectedRows, len = arr.length; i < len; i++) {
         if (row.row.id === arr[i].id) {
            return 'current-row' // elementui高亮样式
         }
       }
    }
   },
   // 鼠标移入时的方法
   handleMouseEnter (row, column, cell, event) {
     this.$emit('handleMouseEnter', {
       row: row,
       column: column,
       event: event
     })
   },
   // 鼠标移出时的方法
   handleMouseLeave (row, column, cell, event) {
     this.$emit('handleMouseLeave', {
       row: row,
       column: column,
       cell: cell,
       event: event
     })
   },
   // 更新排序
   updateOrder () {
     let changeList = {}
     if (this.tableData.length > 0) {
       this.tableData.forEach((item, index) => {
         if (item.id !== this.tableSortData[index].id) {
           this.$set(changeList, this.tableSortData[index].id, item.id)
         }
       })
     }
     if (Object.keys(changeList).length === 0) {
       this.$message({
         message: '请先移动列表排序',
         type: 'warning'
       })
       return
     }
     createAPI(this.updateOrderApi, 'POST', {
       headers: this.currentPreaction.headers,
       data: {
         site: this.metadata.site,
         column: this.updateOrderColumn || this.metadata.column,
         group: this.metadata.group,
         ids: changeList
       }
     }).then(res => {
       if (res.data.status === 0) {
         this.updateOrderDialogVisible = true
         this.FETCH_POST_E5_LIST_DATA()
       }
     })
   }
 }
}
